export default {
  title: 'Tabless',
  form: {
    tabless_id: {
      label: 'ID Tabless',
      placeholder: 'ID interne dans le système Tabless',
    },
  },
  buttons: {
    save: 'Enregistrer',
  },
  toasts: {
    error: "Échec de l'enregistrement des modifications",
    success: 'Modifications enregistrées',
  },
  connected: {
    title: 'Tabless est connecté',
    description: 'Cette intégration est configurée.',
  },
};
